module.exports = __webpack_public_path__ + "img/jianjie3.783db035.jpg";